export default class PayloadParameters {
  constructor ({ storeFilters, productFilters, productDimensions, storeDimensions, metrics, fact, sort }) {
    this.store_filters = storeFilters
    this.product_filters = productFilters
    this.store_dimensions = storeDimensions
    this.product_dimensions = productDimensions
    this.metrics = metrics
    this.fact = fact
    this.sort = sort
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/PayloadParameters.js